'use strict';

/**
 * Converts a value to a boolean.
 *
 * @param prop - The value to convert to a boolean.
 * @returns The boolean representation of the value.
 *
 * @todo This isn't a very useful function. It's just a wrapper around `Boolean()`.
 */ function toBoolean(prop) {
    return Boolean(prop);
}

module.exports = toBoolean;
